import { useTranslation } from 'react-i18next';

import { itemByLanguage } from '@/utils/language';

import ConfirmationModal from '@/components/popups/ConfirmationModal';

import { useFocusAdminState } from '../../state';

import { toggleCategoryVisibility } from './actions';

const ToggleVisibilityModal: React.FC = () => {
  const { t } = useTranslation();
  const { selectedCountry } = useFocusAdminState('selectedCountry');
  const { visibilityModalState, setVisibilityModalState } = useFocusAdminState(
    'visibilityModalState',
  );
  const { category, isFeatured, categoryIndex } = visibilityModalState;

  return (
    <ConfirmationModal
      bodyText={
        category?.enabled
          ? t('Admin.immediatelyMakeHiddenCategoryBody', {
              categoryName: itemByLanguage(category.name, ''),
              countryName: selectedCountry.label,
            })
          : t('Admin.immediatelyMakeVisibleCategoryBody', {
              categoryName: itemByLanguage(category?.name, ''),
              countryName: selectedCountry.label,
            })
      }
      headerText={
        category?.enabled
          ? t('Admin.makeHiddenHeader')
          : t('Admin.makeVisibleHeader')
      }
      isOpen={visibilityModalState.open}
      onClose={() =>
        setVisibilityModalState(prev => ({ ...prev, open: false }))
      }
      primaryButtonColor={category?.enabled ? 'primary' : 'secondary'}
      primaryButtonHandler={() => {
        if (!category || categoryIndex === undefined) {
          return;
        }
        toggleCategoryVisibility(categoryIndex, isFeatured);
      }}
      primaryButtonText={
        category?.enabled ? t('Button.makeHidden') : t('Button.makeVisible')
      }
      secondaryButtonHandler={() =>
        setVisibilityModalState(prev => ({ ...prev, open: false }))
      }
      secondaryButtonText={t('Button.cancel')}
    />
  );
};

export default ToggleVisibilityModal;
